<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span style="cursor: pointer" @click="back">甲醇</span> > 库存</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>库存</p>
        <div class="btn fr">搜索</div>
        <input class="fr" type="text" placeholder="请输入关键词">
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="goDetail(item.completeOriginalDate, queryParams['dictDataType'])">{{ item.date + '甲醇库存'}}</p>
          <span class="fr">{{ item.completeOriginalDate }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;" @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams['pageSize']"
          :current-page="queryParams['pageNum']"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;" @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  stockPage,
} from '@/api/methanol'

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryParams:{
        pageNum:1,
        pageSize:15,
        dictDataType:'issue_methanol_stock_area',
        dataType:2
      }
    }
  },
  created() {
    if (this.$route.query.flag) {
      this.queryParams['dictDataType'] = this.$route.query.flag;
    }
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      stockPage(this.queryParams).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.queryParams['dictDataType'] = num;
      this.getList();
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      this.$router.push({path:`/methanol/stock`, query:{id}})
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/methanol')
    },
    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.getList();
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
